export const parseJsonStrings = <T = unknown>(input: T, depth = 0): T => {
  if (Array.isArray(input)) {
    return input.map(item => parseJsonStrings(item, depth + 1)) as unknown as T;
  }

  if (input && typeof input === "object") {
    const result: Record<string, unknown> = {};

    Object.entries(input as Record<string, unknown>).forEach(([key, value]) => {
      if (typeof value === "string") {
        const trimmed = value.trim();
        const looksLikeObjectOrArray =
          (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
          (trimmed.startsWith("[") && trimmed.endsWith("]"));

        if (looksLikeObjectOrArray) {
          try {
            const parsedValue = JSON.parse(trimmed);
            result[key] = parseJsonStrings(parsedValue, depth + 1);
            return;
          } catch {
            console.error("Invalid JSON string", trimmed);
          }
        }

        result[key] = value;
      } else {
        result[key] = parseJsonStrings(value, depth + 1);
      }
    });

    return result as T;
  }

  return input;
};
